import { Row, Col, Typography, Spin, Image } from 'antd';
import { useQuery } from 'react-query';
import ContractTripsResults from './ContractTrips/ContractTripsResults';
import PackageUsage from './PackageUsage/PackageUsage';
import KilometresUsage from './KilometresUsage/kilometresUsage';
import ContractInfo from './ContractInfo/ContractInfo';
import EndPoints from '../../shared/endPoints/EndPoints.json';
import { useAuthContext } from '../../shared/context/auth-context';
import useHttpClient from '../../shared/sendRequest/useHttpClient';
import styles from './styles';

import carIcon from '../../assets/Car and checkmark 2.png';
import './homePage.css';

function useContractInfo() {
  const { sendRequest } = useHttpClient();
  const { ContractId } = useAuthContext();
  return useQuery('getContractInfo', async () =>
    sendRequest({
      endpoint: `${EndPoints.CONTRACT.CONTRACT}/${ContractId}`,
      method: 'GET'
    })
  );
}

function useContractNotificationMessage() {
  const { sendRequest } = useHttpClient();
  return useQuery('getNotificationMessage', async () =>
    sendRequest({
      endpoint: EndPoints.NOTIFICATION.NOTIFICATION,
      method: 'GET'
    })
  );
}

export default function HomePage() {
  const { Title, Text } = Typography;
  const { status, data } = useContractInfo();
  const { status: notificationStatus, data: notificationData } =
    useContractNotificationMessage();

  if (status === 'loading' || notificationStatus === 'loading') {
    return (
      <Row justify="center">
        <Col>
          <Spin size="large" />
        </Col>
      </Row>
    );
  }

  return (
    <div style={styles.container}>
      <Row>
        <Col className="message">
          <Text style={{ fontWeight: 'bold' }}>
            {notificationData?.description}
          </Text>
        </Col>
      </Row>
      {data ? (
        <>
          <Row
            align="middle"
            justify="space-between"
            style={{ marginBottom: 32 }}
          >
            <Col>
              <Title>Καλώς ήρθες στο Shortdrive!</Title>
            </Col>
            <Col>
              <div style={styles.plateBadge}>
                <Row align="middle" justify="center" gutter={6}>
                  <Col>
                    <Image src={carIcon} width={28} preview={false} />
                  </Col>
                  <Col>
                    <Text type="secondary" style={{ fontSize: 13 }}>
                      ΑΡΙΘΜΟΣ ΚΥΚΛΟΦΟΡΙΑΣ
                    </Text>
                  </Col>
                </Row>
                <Text strong style={{ fontSize: 16 }}>
                  {data.plateNumber}
                </Text>
              </div>
            </Col>
          </Row>

          <Row gutter={[16, 16]}>
            <Col xs={24} lg={12}>
              <ContractInfo />
            </Col>
            <Col xs={24} lg={12}>
              <KilometresUsage />
            </Col>
            <Col xs={24} lg={12}>
              <ContractTripsResults />
            </Col>
            <Col xs={24} lg={12}>
              <PackageUsage />
            </Col>
          </Row>
        </>
      ) : (
        <Row justify="center">
          <Col>Τα δεδομένα δεν είναι διαθέσιμα αυτή τη στιγμή</Col>
        </Row>
      )}
    </div>
  );
}
